export interface AmountRatioAPIResponse {
  member_paid: number;
  plan_paid: number;
  member_paid_ratio: number;
  plan_paid_percentage: number;
  total_paid: number;
  network_indicator: string;
}

export interface NetworkSummaryAPIResponse {
  claims: number;
  memberPaid: number;
  planPaid: number;
  providerName: string;
  providerType: string;
  totalCharge: number;
}

export interface NetworkUtilizationResponse {
  month: number;
  networkIndicator: string;
  totalPlanPaid: number;
  totalmemberPaid: number;
  year: number;
}

export interface NetworkUtilizationApiResponse {
  startFromMonth: number;
  startFromYear: number;
  in: NetworkUtilizationResponse[];
  out: NetworkUtilizationResponse[];
}

export const outNetworkColumns = [
  'Member ID',
  'Claim Count',
  'Plan Paid',
  'Total Paid',
  'Enrollment Status',
  'Costliest Drugs',
  'Gender',
  'Age',
  'First Name',
  'Last Name',
  'Member Relationship',
  'DOB',
];

export const defaultOutNetworkMembersColumns = [
  'Member ID',
  'Claim Count',
  'Plan Paid',
  'Total Paid',
];
